<template>
	<el-dialog v-dialogDrag class="modify-password" title="修改密码" :visible.sync="visible" width="420px"
		:modal-append-to-body="false" :append-to-body="true" top="25vh"
		:before-close="onClose">
		<el-form :model="form" label-width="100px" :rules="rules" ref="modifyPwdForm" size="small">
			<el-form-item label="原密码" prop="oldPassword">
				<el-input type="password" v-model="form.oldPassword" autocomplete="off" size="small"
					placeholder="请输入原密码" show-password></el-input>
			</el-form-item>
			<el-form-item label="新密码" prop="newPassword">
				<el-input type="password" v-model="form.newPassword" autocomplete="off" size="small"
					placeholder="请输入新密码" show-password></el-input>
			</el-form-item>
			<el-form-item label="确认新密码" prop="confirmPassword">
				<el-input type="password" v-model="form.confirmPassword" autocomplete="off" size="small"
					placeholder="请再次输入新密码" show-password></el-input>
			</el-form-item>
		</el-form>

		<span slot="footer" class="dialog-footer">
			<el-button @click="onClose()">取 消</el-button>
			<el-button type="primary" @click="onSubmit()">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: "modifyPassword",
	data() {
		// 校验确认密码是否一致
		const validateConfirmPassword = (rule, value, callback) => {
			if (value !== this.form.newPassword) {
				callback(new Error('两次输入的新密码不一致'));
			} else {
				callback();
			}
		};
		return {
			form: {
				oldPassword: '',
				newPassword: '',
				confirmPassword: ''
			},
			rules: {
				oldPassword: [{
					required: true,
					message: '请输入原密码',
					trigger: 'blur'
				}],
				newPassword: [{
					required: true,
					message: '请输入新密码',
					trigger: 'blur'
				}, {
					min: 6,
					message: '密码长度不能少于6位',
					trigger: 'blur'
				}],
				confirmPassword: [{
					required: true,
					message: '请再次输入新密码',
					trigger: 'blur'
				}, {
					validator: validateConfirmPassword,
					trigger: 'blur'
				}]
			}
		}
	},
	methods: {
		onClose() {
			this.$refs['modifyPwdForm'].resetFields();
			this.$emit("close");
		},
		onSubmit() {
			this.$refs['modifyPwdForm'].validate((valid) => {
				if (!valid) {
					return false;
				}
				this.$http({
					url: "/modifyPwd",
					method: "put",
					data: this.form
				}).then(() => {
					this.$refs['modifyPwdForm'].resetFields();
					this.$emit("close");
					this.$message.success("密码修改成功，请重新登录");
					// 修改成功后退出登录
					setTimeout(() => {
						this.$emit("logout");
					}, 1500);
				})
			});
		}
	},
	props: {
		visible: {
			type: Boolean
		}
	}
}
</script>

<style lang="scss" scoped>
.modify-password {
	.el-form {
		padding: 20px 20px 0 10px;
	}
}
</style>
